/* eslint-disable camelcase */
import {
  LineSectionSeatFaresInterface,
  FareTaxInterface,
} from 'store/ducks/lines/types';
import { AddressInterface } from './address.interface';

/** sendable data */
export interface PointFormBase {
  id: string;
  busStop: number; // boolean
  busTurn: number; // boolean
  // way: number; (inserted during form submission)
  // order: number; (inserted during form submission)
}

/** complementary data */
export interface PointFormCompl {
  id: string;
  name: string;
  covered: number; // boolean
  busBay: number; // boolean
  visible: boolean;
  startLat: number;
  startLong: number;
  endLat: number;
  endLong: number;
  radius?: number;
  Address: AddressInterface;
  type?: number;
  order?: number;
  Toll?: {
    id: string;
    name: string;
    value: number;
  };
  Terminal?: {
    id: string;
    name: string;
    schedules: string; // json
    elevators: string;
    escalators: string;
    stairs: string;
    accessRamps: string;
    tactileFloor: string;
    publicToilets: string;
    suggestionBox: string;
    sink: string;
    accessibleSink: string;
    integrationStation: string;
    wifi: string;
    foodCourt: string;
    bikeStation: string;
    bikeRack: string;
  };
}

export interface PointFormInterface extends PointFormBase, PointFormCompl {}

export interface FareFormInterface {
  id: string;
  name: string;
  value: number;
  subsidy: number;
}

export type SeatFareType = 'FIXED' | 'PERCENTAGE';
export type TicketSalesSeatFareType = 'FIXED_VALUE' | 'PERCENTAGE';
export type SeatFareOperation = 'ADD' | 'REMOVE';

export interface SeatFareFormItemInterface {
  value: number;
  type: TicketSalesSeatFareType;
  operation?: SeatFareOperation;
}

export interface SeatFaresFormInterface {
  STANDARD: SeatFareFormItemInterface;
  EXECUTIVE: SeatFareFormItemInterface;
  SLEEPER_BED: SeatFareFormItemInterface;
  BED: SeatFareFormItemInterface;
  DOUBLE_BED: SeatFareFormItemInterface;
}
export interface SectionFormInterface {
  key: string;
  startStopId: string | null;
  endStopId: string | null;
  fare: FareFormInterface | null;
  km: string;
  name: string;
  toll?: Array<any>;
  FareTaxes?: FareTaxInterface[];
  LineSectionSeatFares?: LineSectionSeatFaresInterface[];
}
export const SEAT_FARE_KEY_BY_SEAT_TYPE: Record<
  string,
  keyof SeatFaresFormInterface
> = {
  0: 'STANDARD',
  1: 'EXECUTIVE',
  2: 'SLEEPER_BED',
  3: 'BED',
  4: 'DOUBLE_BED',
};
export interface WayFormInterface {
  geoJson: any | null;
  points: Array<PointFormInterface>;
  sections: Array<SectionFormInterface>;
}

export interface LinePathFormInterface {
  key: string;
  name: string;
  type: number; // go | go and back
  go: WayFormInterface;
  back: WayFormInterface;
  // order: number; // groups go and back of a path (inserted during form submission)
}

export interface LineFormInterface {
  general: {
    name: string;
    status: number;
    visible: boolean;
    sellingAllowed: boolean;
    blockByCount: boolean;
    automaticChangeGo: boolean;
    automaticChangeBack: boolean;
    bpe: boolean;
    profileReservations: { id: string; quantity: number }[];
    freeTerminalOnly: boolean;
    freeTimeLimit: number;
    prefix: string;
    type: number;
    distributionType: number;
    lineType: number;
    lineFunction: number;
    model: number;
    sector: string;
    system: string;
    operation: number;
    minVelocity: number;
    maxVelocity: number;
    color: any;
    lineLot: { id: string; name: string; color: string } | null;
  };
  paths: Array<LinePathFormInterface>;
  points: {
    currentPath: { key: string; way: number };
  };
  tolls: {
    currentPath: {
      key: string;
      way: number;
      goValues: Array<{
        id: string;
        selected: boolean;
      }>;
      backValues: Array<{
        id: string;
        selected: boolean;
      }>;
    };
  };
  fares: {
    currentPath: { key: string; way: number };
  };
  benefits: {
    benefitIds: Array<string>;
  };
}
